module.exports = __webpack_public_path__ + "img/error-page-bg.14893fb.png";